(function () {
  const selectors = {
    drawer: '[data-nevex-cart-drawer]',
    panel: '[data-cart-drawer-panel]',
    overlay: '[data-cart-drawer-overlay]',
    close: '[data-cart-drawer-close]',
    items: '[data-cart-drawer-items]',
    empty: '[data-cart-drawer-empty]',
    footer: '[data-cart-drawer-footer]',
    subtotal: '[data-cart-drawer-subtotal]',
    discounts: '[data-cart-drawer-discounts]',
    promo: '[data-cart-drawer-promo]',
    error: '[data-cart-drawer-error]',
    openers: '[data-cart-drawer-open], #cart-icon-bubble, a[href="/cart"], a[href$="/cart"]'
  };

  const drawer = document.querySelector(selectors.drawer);
  if (!drawer) return;

  const panel = drawer.querySelector(selectors.panel);
  const overlay = drawer.querySelector(selectors.overlay);
  const closeButton = drawer.querySelector(selectors.close);
  const itemsContainer = drawer.querySelector(selectors.items);
  const emptyState = drawer.querySelector(selectors.empty);
  const footer = drawer.querySelector(selectors.footer);
  const subtotal = drawer.querySelector(selectors.subtotal);
  const discounts = drawer.querySelector(selectors.discounts);
  const promo = drawer.querySelector(selectors.promo);
  const errorMessage = drawer.querySelector(selectors.error);
  const moneyFormat = drawer.dataset.moneyFormat || '{{amount}}';
  const shippingProgress = drawer.querySelector('[data-free-shipping-progress]');
  const shippingBar = drawer.querySelector('[data-free-shipping-bar]');
  const shippingCopy = drawer.querySelector('[data-free-shipping-copy]');
  const shippingStatus = drawer.querySelector('[data-free-shipping-status]');
  const checkoutForm = drawer.querySelector('[data-cart-drawer-checkout-form]');
  const checkoutButton = checkoutForm && checkoutForm.querySelector('button[type="submit"]');
  const shippingThreshold = Number(drawer.dataset.freeShippingThreshold || 0);
  const checkoutButtonLabel = checkoutButton ? checkoutButton.textContent : '';
  let cart = null;
  let isOpen = false;
  let lastActiveElement = null;
  let scrollY = 0;
  let checkoutResetTimer = null;

  function getCartUrl(suffix) {
    const base = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    return suffix ? `${base}${suffix}` : base;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(Number(cents || 0), moneyFormat);
    }
    const value = Number(cents || 0) / 100;
    const placeholder = (moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/) || [null, 'amount'])[1];
    const decimals = placeholder.includes('no_decimals') ? 0 : 2;
    const decimalMark = placeholder.includes('comma_separator') ? ',' : '.';
    const thousands = placeholder.includes('comma_separator') ? '.' : ',';
    const parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const amount = decimals ? `${parts[0]}${decimalMark}${parts[1]}` : parts[0];
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function setLoading(loading) {
    drawer.classList.toggle('is-loading', Boolean(loading));
  }

  function showError(message) {
    if (!errorMessage) return;
    errorMessage.textContent = message || '';
    errorMessage.hidden = !message;
  }

  function resetCheckoutState() {
    drawer.classList.remove('is-checking-out');
    if (checkoutResetTimer) {
      window.clearTimeout(checkoutResetTimer);
      checkoutResetTimer = null;
    }
    if (checkoutButton) {
      checkoutButton.disabled = false;
      checkoutButton.textContent = checkoutButtonLabel;
    }
  }

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  }

  function lockPageScroll() {
    scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('nevex-cart-drawer-open');
    document.body.classList.add('nevex-cart-drawer-open');
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('nevex-cart-drawer-open');
    document.body.classList.remove('nevex-cart-drawer-open');
    if (Math.abs((window.scrollY || 0) - scrollY) > 1) {
      const previousScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, scrollY);
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
    }
  }

  function updateCartCounts(nextCart) {
    const count = nextCart ? nextCart.item_count : 0;

    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
    });

    document.querySelectorAll('[data-cart-cta]').forEach((element) => {
      element.hidden = false;
    });

    document.querySelectorAll('#cart-icon-bubble').forEach((link) => {
      if (count > 0 && !link.querySelector('.cart-count-bubble')) {
        const bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        link.appendChild(bubble);
      }
    });

    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      bubble.hidden = count === 0;
      const visibleCount = bubble.querySelector('[aria-hidden="true"]');
      if (visibleCount) visibleCount.textContent = count < 100 ? count : '';
      const accessibleCount = bubble.querySelector('.visually-hidden');
      if (accessibleCount) accessibleCount.textContent = `${count} продукта`;
    });
  }

  function getItemMeta(item) {
    const meta = [];
    if (item.variant_title && item.variant_title !== 'Default Title') meta.push(item.variant_title);
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      meta.push(item.selling_plan_allocation.selling_plan.name);
    }
    return meta.join(' / ');
  }

  function renderDiscounts(nextCart) {
    const applications = [];

    (nextCart.cart_level_discount_applications || []).forEach((discount) => {
      applications.push({
        title: discount.title,
        amount: discount.total_allocated_amount
      });
    });

    if (!applications.length) {
      discounts.hidden = true;
      discounts.innerHTML = '';
      return;
    }

    discounts.hidden = false;
    discounts.innerHTML = applications.map((discount) => `
      <div class="nevex-cart-drawer__discount-row">
        <span>${escapeHTML(discount.title)}</span>
        <span>-${formatMoney(discount.amount)}</span>
      </div>
    `).join('');
  }

  function renderItems(nextCart) {
    if (!nextCart.items.length) {
      itemsContainer.innerHTML = '';
      emptyState.hidden = false;
      footer.hidden = true;
      promo.hidden = true;
      return;
    }

    emptyState.hidden = true;
    footer.hidden = false;
    renderUpsells(nextCart);

    itemsContainer.innerHTML = nextCart.items.map((item) => {
      const meta = getItemMeta(item);
      const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=152` : '';
      const image = item.image
        ? `<img src="${escapeHTML(imageUrl)}" alt="${escapeHTML(item.product_title)}" loading="lazy">`
        : '';
      const hasCompare = item.original_line_price > item.final_line_price;
      const discountBadge = (item.discounts || []).length
        ? `<span class="nevex-cart-drawer__badge">${escapeHTML(item.discounts[0].title)}</span>`
        : '';

      return `
        <article class="nevex-cart-drawer__item" data-cart-line-key="${escapeHTML(item.key)}">
          <a class="nevex-cart-drawer__item-image" href="${escapeHTML(item.url)}" tabindex="-1">${image}</a>
          <div class="nevex-cart-drawer__item-info">
            <div class="nevex-cart-drawer__item-top">
              <div>
                <a class="nevex-cart-drawer__item-title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
                ${meta ? `<p class="nevex-cart-drawer__item-meta">${escapeHTML(meta)}</p>` : ''}
                ${discountBadge}
              </div>
              <div class="nevex-cart-drawer__price">
                ${hasCompare ? `<span class="nevex-cart-drawer__compare">${formatMoney(item.original_line_price)}</span>` : ''}
                <span>${formatMoney(item.final_line_price)}</span>
              </div>
            </div>
            <div class="nevex-cart-drawer__item-actions">
              <div class="nevex-cart-drawer__qty" aria-label="Aantal voor ${escapeHTML(item.product_title)}">
                <button type="button" data-cart-drawer-quantity="${item.quantity - 1}" data-cart-drawer-key="${escapeHTML(item.key)}" aria-label="Aantal verlagen">-</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-drawer-quantity="${item.quantity + 1}" data-cart-drawer-key="${escapeHTML(item.key)}" aria-label="Aantal verhogen">+</button>
              </div>
              <button class="nevex-cart-drawer__remove" type="button" data-cart-drawer-quantity="0" data-cart-drawer-key="${escapeHTML(item.key)}">Verwijderen</button>
            </div>
          </div>
        </article>
      `;
    }).join('');
  }

  function renderUpsells(nextCart) {
    if (!promo) return;
    const productIds = new Set(nextCart.items.map((item) => String(item.product_id)));
    let visible = 0;

    promo.querySelectorAll('[data-cart-upsell-product]').forEach((card) => {
      const shouldShow = !productIds.has(String(card.dataset.productId)) && visible < 2;
      card.hidden = !shouldShow;
      if (shouldShow) visible += 1;
    });

    promo.hidden = visible === 0;
  }

  function render(nextCart) {
    showError('');
    cart = nextCart;
    renderItems(nextCart);
    renderDiscounts(nextCart);
    subtotal.textContent = formatMoney(nextCart.total_price);
    updateCartCounts(nextCart);
    if (shippingProgress) {
      const enabled = drawer.dataset.freeShippingEnabled === 'true' && shippingThreshold > 0 && nextCart.items.length > 0;
      shippingProgress.hidden = !enabled;
      if (enabled) {
        const remaining = Math.max(0, shippingThreshold - nextCart.total_price);
        const progress = Math.min(100, Math.round((nextCart.total_price / shippingThreshold) * 100));
        shippingBar.style.width = `${progress}%`;
        shippingStatus.textContent = `${progress}%`;
        const template = remaining > 0 ? drawer.dataset.freeShippingMessage : drawer.dataset.freeShippingUnlocked;
        shippingCopy.textContent = String(template || '').replace('[amount]', formatMoney(remaining));
      }
    }
    dispatch('cart:updated', { cart: nextCart });
  }

  async function fetchCart() {
    const response = await fetch(getCartUrl('.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('Количката не можа да се зареди.');
    return response.json();
  }

  async function refreshCart() {
    const nextCart = await fetchCart();
    render(nextCart);
    return nextCart;
  }

  async function changeQuantity(key, quantity) {
    setLoading(true);
    showError('');

    try {
      const response = await fetch(window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: Number(quantity) })
      });

      if (!response.ok) throw new Error('Количеството не можа да се промени. Опитай отново.');
      render(await response.json());
    } catch (error) {
      showError(error.message);
    } finally {
      setLoading(false);
    }
  }

  function getFocusableElements() {
    return Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter((element) => element.offsetParent !== null);
  }

  async function openDrawer(options) {
    lastActiveElement = document.activeElement;
    drawer.classList.add('is-open');
    if (!isOpen) lockPageScroll();
    panel.setAttribute('aria-hidden', 'false');
    panel.removeAttribute('inert');
    isOpen = true;

    if (!cart || (options && options.refresh)) {
      try {
        setLoading(true);
        await refreshCart();
      } finally {
        setLoading(false);
      }
    }

    window.requestAnimationFrame(() => {
      (closeButton || panel).focus({ preventScroll: true });
    });

    dispatch('cart:drawer:open', { cart });
  }

  function closeDrawer() {
    if (!isOpen) return;
    drawer.classList.remove('is-open');
    unlockPageScroll();
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
    isOpen = false;

    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus({ preventScroll: true });
    }

    dispatch('cart:drawer:close', { cart });
  }

  async function addToCart(form) {
    setLoading(true);

    try {
      const response = await fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('Продуктът не можа да се добави.');
      await refreshCart();
      await openDrawer();
    } finally {
      setLoading(false);
    }
  }

  async function addVariant(variantId, button) {
    setLoading(true);
    showError('');
    if (button) button.disabled = true;

    try {
      const response = await fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });

      if (!response.ok) throw new Error('Продуктът не можа да се добави.');
      await refreshCart();
    } catch (error) {
      showError(error.message);
    } finally {
      if (button) button.disabled = false;
      setLoading(false);
    }
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest(selectors.openers);
    if (opener && opener.closest('.nevex-cart-drawer') === null) {
      event.preventDefault();
      openDrawer({ refresh: true });
      return;
    }

    const quantityButton = event.target.closest('[data-cart-drawer-key][data-cart-drawer-quantity]');
    if (quantityButton) {
      event.preventDefault();
      changeQuantity(quantityButton.dataset.cartDrawerKey, quantityButton.dataset.cartDrawerQuantity);
      return;
    }

    const upsellButton = event.target.closest('[data-cart-upsell-add]');
    if (upsellButton) {
      event.preventDefault();
      addVariant(upsellButton.dataset.cartUpsellAdd, upsellButton);
      return;
    }

    if (event.target.closest(selectors.close) || event.target === overlay) {
      event.preventDefault();
      closeDrawer();
    }
  });

  drawer.addEventListener('touchmove', (event) => {
    if (!isOpen) return;
    if (!event.target.closest('.nevex-cart-drawer__panel')) {
      event.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('submit', (event) => {
    if (event.target.closest('[data-cart-drawer-checkout-form]')) {
      drawer.classList.add('is-checking-out');
      if (checkoutButton) {
        checkoutButton.disabled = true;
        checkoutButton.textContent = 'Отваря се страницата за плащане…';
      }
      checkoutResetTimer = window.setTimeout(resetCheckoutState, 8000);
      return;
    }

    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.closest('.nevex-cart-drawer') || form.closest('product-form')) return;

    event.preventDefault();
    addToCart(form).catch((error) => {
      console.error(error);
      form.submit();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (!isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements();
    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('cart:refresh', () => {
    refreshCart().catch(() => showError('Количката не можа да се обнови. Опитай отново.'));
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      refreshCart()
        .then(() => openDrawer())
        .catch(() => showError('Продуктът е добавен, но количката не можа да се обнови.'));
    });
  }

  window.addEventListener('pagehide', resetCheckoutState);
  window.addEventListener('pageshow', resetCheckoutState);

})();
